module.exports = __webpack_public_path__ + "files/143790174b3320b119ed724befcd0ef4.png";